import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Typography,
  Button,
  Input,
  Modal,
  Popconfirm,
  Form,
  Checkbox,
  Card,
  Row,
  Col,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { formatDateTime } from '../../../utils/string';

import config from './AdminTax.component.config';
import './AdminTax.component.styles.css';

const { Title, Text } = Typography;

const AdminTax = ({ ...props }) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    needMounting: true,
    showdpp: false,
  });
  const formRef = React.useRef();
  const formRefPph = React.useRef();

  const mountingFirstData = () => {
    props.taxList().then(() => {
      console.log(props.tax_setting);

      setTimeout(() => {
        formRef.current.setFieldsValue({
          tax_name: props.tax_setting.data.ppn.tax_name,
          tax_rate: props.tax_setting.data.ppn.tax_rate,
          use_dpp: props.tax_setting.data.ppn.use_dpp,
          calculation_dpp: props.tax_setting.data.ppn.calculation_dpp,
        });
        formRefPph.current.setFieldsValue({
          tax_name: props.tax_setting.data.pph.tax_name,
          tax_rate: props.tax_setting.data.pph.tax_rate,
        });
        setState((prevState) => {
          const currentState = { ...prevState };
          currentState.showdpp = props.tax_setting.data.ppn.use_dpp;
          return { ...currentState };
        });
      }, 500);
    });

    setState((prevState) => {
      const currentState = { ...prevState };
      currentState.needMounting = false;
      return { ...currentState };
    });
  };
  useEffect(() => {
    if (state.needMounting) mountingFirstData();
  });

  const submitTax = () => {
    const formData = formRef.current.getFieldsValue();
    if (props.tax_setting.data.ppn.id === null) {
      // create
      props.taxCreate({ type: 'ppn', ...formData }).then(() => {
        props.taxList();
      });
    } else {
      // update
      const dataUpdate = {
        id: props.tax_setting.data.ppn.id,
        type: 'ppn',
        ...formData,
      };
      props.taxUpdate(dataUpdate).then(() => {
        props.taxList();
      });
    }
  };
  const submitTaxPph = () => {
    const formData = formRefPph.current.getFieldsValue();
    if (props.tax_setting.data.pph.id === null) {
      // create
      props.taxCreate({ type: 'pph', ...formData }).then(() => {
        props.taxList();
      });
    } else {
      // update
      const dataUpdate = {
        id: props.tax_setting.data.pph.id,
        type: 'pph',
        ...formData,
      };
      props.taxUpdate(dataUpdate).then(() => {
        props.taxList();
      });
    }
  };

  return (
    <div id="AdminTax">
      <div className="AdminTax__header">
        <Title level={3}>Tax Configuration</Title>
        <Text type="secondary">Configure your tax settings here.</Text>
        <br />
      </div>
      <br />
      <Card
        title={
          <Title level={4}>
            PPN Configuration <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              last modified:{' '}
              {formatDateTime(props.tax_setting.data.ppn?.modified_at)}
            </Text>
          </Title>
        }
      >
        <Row gap={24} justify="space-between">
          <Col md={24} lg={12} xl={12}>
            <Form
              style={{ marginTop: 10 }}
              ref={formRef}
              layout="horizontal"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 12 }}
              onFinish={submitTax}
            >
              <Form.Item
                hidden
                label="Nama Pajak"
                name="tax_name"
                rules={[
                  {
                    required: true,
                    message: 'Dont make me empty :(',
                  },
                ]}
              >
                <Input placeholder="Tax Name..." />
              </Form.Item>
              <Form.Item
                label="Persentase Pajak"
                name="tax_rate"
                rules={[
                  {
                    required: true,
                    message: 'Dont make me empty :(',
                  },
                ]}
              >
                <Input placeholder="Tax Rate..." type="number" prefix="%" />
              </Form.Item>
              <Form.Item
                label="Pakai DPP"
                name="use_dpp"
                valuePropName="checked"
              >
                <Checkbox
                  onChange={(e) => {
                    setState((prevState) => {
                      const currentState = { ...prevState };
                      currentState.showdpp = e.target.checked;
                      return { ...currentState };
                    });
                  }}
                />
              </Form.Item>
              <Form.Item
                label="Perhitungan DPP"
                name="calculation_dpp"
                hidden={!state.showdpp}
              >
                <Input placeholder="need use symbol '/' example 11/12 " />
              </Form.Item>
              <div className="button-action">
                <Button htmlType="submit" type="primary">
                  Simpan
                </Button>
              </div>
            </Form>
          </Col>
          <Col md={24} lg={12} xl={12}>
            <div>
              <span
                style={{
                  fontSize: 14,
                  color: '#8c8a8a',
                  fontWeight: 'bold',
                }}
              >
                History Perubahan.
              </span>
              <br />
            </div>
            {props.tax_setting.data.ppn?.history?.map((item, index) => (
              <div
                style={{
                  padding: 10,
                  border: '1px solid #e8e8e8',
                  borderRadius: 5,
                  marginBottom: 10,
                }}
              >
                <Text type="secondary">Persentase : {item.tax_rate} %</Text>
                <br />
                {item.use_dpp && (
                  <Text type="secondary">
                    Perhitungan DPP : {item.calculation_dpp}
                    <br />
                  </Text>
                )}
                <Text type="secondary">{formatDateTime(item.modified_at)}</Text>
              </div>
            ))}
          </Col>
        </Row>
      </Card>
      <br />
      <Card
        title={
          <Title level={4}>
            PPH Configuration <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              last modified:{' '}
              {formatDateTime(props.tax_setting.data.pph?.modified_at)}
            </Text>
          </Title>
        }
      >
        <Row gap={24} justify="space-between">
          <Col md={24} lg={12} xl={12}>
            <Form
              style={{ marginTop: 10 }}
              ref={formRefPph}
              layout="horizontal"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 8 }}
              onFinish={submitTaxPph}
            >
              <Form.Item
                hidden
                label="Nama Pajak"
                name="tax_name"
                rules={[
                  {
                    required: true,
                    message: 'Dont make me empty :(',
                  },
                ]}
              >
                <Input placeholder="Tax Name..." />
              </Form.Item>
              <Form.Item
                label="Persentase Pajak"
                name="tax_rate"
                rules={[
                  {
                    required: true,
                    message: 'Dont make me empty :(',
                  },
                ]}
              >
                <Input placeholder="Tax Rate..." type="number" prefix="%" />
              </Form.Item>
              <div className="button-action">
                <Button htmlType="submit" type="primary">
                  Simpan
                </Button>
              </div>
            </Form>
          </Col>
          <Col md={24} lg={12} xl={12}>
            <div>
              <span
                style={{
                  fontSize: 14,
                  color: '#8c8a8a',
                  fontWeight: 'bold',
                }}
              >
                History
              </span>
              <br />
            </div>
            {props.tax_setting.data.pph?.history?.map((item, index) => (
              <div
                style={{
                  padding: 10,
                  border: '1px solid #e8e8e8',
                  borderRadius: 5,
                  marginBottom: 10,
                }}
              >
                <Text type="secondary">Persentase: {item.tax_rate} %</Text>
                <br />
                <Text type="secondary">{formatDateTime(item.modified_at)}</Text>
              </div>
            ))}
          </Col>
        </Row>
      </Card>
    </div>
  );
};

AdminTax.displayName = config.displayName;
AdminTax.defaultProps = config.defaultProps;
AdminTax.propTypes = config.propTypes;

export default AdminTax;
